export default __webpack_public_path__ + "static/media/twitter2.6ea7be3c.svg";